import exponent from "./exponent.js";

export default function(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-format/src/precisionFixed.js
// module id = ./node_modules/d3-format/src/precisionFixed.js
// module chunks = vendor